import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
          <i className="ri-emotion-sad-line text-2xl" />
        </span>
        <h1 className="mt-6 font-brand text-5xl text-primary-700">404</h1>
        <p className="mt-3 text-base text-foreground-700">抱歉，没有找到这个页面</p>
        <p className="mt-2 text-sm text-foreground-500">
          页面可能已被移除，或者链接地址有误。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-home-line text-base" />
            </span>
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-base" />
            </span>
            去搜索影视
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}